import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Accent, SectionHeading } from './SectionHeading';
import { audience } from '../../data/content';
export function AudienceSection() {
  return <section aria-labelledby="audience-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-24" data-id="element-35" data-mp="1y94wvlps811y">
      <div className="mx-auto max-w-3xl" data-id="element-36" data-mp="1t90nsgr7e8lr">
        <SectionHeading id="audience-heading" title={<>
              Nail Educator Ready™ est fait pour vous <Accent data-id="element-38" data-mp="237q0zw85n4vo">si…</Accent>
            </>} data-id="element-37" data-mp="1t87ep94rv70g" />

        <ul className="mt-12 divide-y divide-brand-charcoal/10 border-y border-brand-charcoal/10" role="list" data-id="element-39" data-mp="237g8a0vq6jma">
          {audience.map(item => <li key={item} className="flex items-start gap-4 py-5" data-id="element-40" data-mp="2cwzsb9v6cjiq">
              <span className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-brand-cta" data-id="element-41" data-mp="2czvqmzaxpa7p">
                <CheckIcon className="h-4 w-4 text-white" strokeWidth={3} aria-hidden="true" data-id="element-42" data-mp="2ly7krbb0eq4w" />
              </span>
              <span className="pt-1 text-[16px] leading-snug text-brand-charcoal sm:text-[17px]" data-id="element-43" data-mp="1sc3z40rml5hi">{item}</span>
            </li>)}
        </ul>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-[1.6rem] font-bold leading-snug text-brand-charcoal sm:text-[1.9rem]" data-id="element-44" data-mp="1xaxexzudx8ku">
          Vous avez déjà les connaissances. <Accent data-id="element-45" data-mp="26c54ntiu513b">Nail Educator Ready™ vous aide à mieux les transmettre.</Accent>
        </p>
      </div>
    </section>;
}